module.exports = __webpack_public_path__ + "img/botones_de_22_y_30_mm.22ec5651.jpg";